import React, { useEffect, useState } from 'react';

import { MEDIOS_DE_MOSTRADOR, cobraEnMostrador, lectorDeTienda } from '../utils/cobroPendiente';

const POS = 5;

// "¿Con qué pagó?" al cobrar en el mostrador un ticket pendiente (ver utils/cobroPendiente). Arranca
// en el medio que el ticket ya tiene —"Pago en tienda" llega como efectivo— y, con tarjeta, pide
// por cuál lector entró; el selector de lector aparece sólo si hay más de uno, como en la venta.
//
// Guarda su propio estado y avisa cada cambio por `onChange({ paymentType, posDeviceId })`, también
// el inicial: la grilla de Tickets lo lee recién al confirmar, desde un campo de instancia.
// Los lectores los carga el padre UNA vez: la grilla dibuja un modal por fila.
export default function CobroPendienteFields({ idPrefix, defaultPaymentType, devices = [], onChange }) {
    const [paymentType, setPaymentType] = useState(
        cobraEnMostrador(defaultPaymentType) ? Number(defaultPaymentType) : MEDIOS_DE_MOSTRADOR[0].code
    );
    const [posDeviceId, setPosDeviceId] = useState('');

    // Los lectores llegan después del primer render: se preselecciona el de la tienda en cuanto
    // están, sin pisar uno que ya se haya elegido.
    useEffect(() => {
        if (posDeviceId === '' && devices.length > 0) {
            const preferido = lectorDeTienda(devices);
            if (preferido) setPosDeviceId(String(preferido.id));
        }
    }, [devices, posDeviceId]);

    useEffect(() => {
        if (typeof onChange === 'function') {
            onChange({ paymentType, posDeviceId: paymentType === POS ? posDeviceId : '' });
        }
    }, [paymentType, posDeviceId]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="mt-3">
            <label htmlFor={`${idPrefix}-medio`}>¿Con qué pagó?</label>
            <select
                id={`${idPrefix}-medio`}
                className="custom-select"
                value={paymentType}
                onChange={(e) => setPaymentType(Number(e.target.value))}>
                {MEDIOS_DE_MOSTRADOR.map((m) => (
                    <option value={m.code} key={m.code}>{m.label}</option>
                ))}
            </select>
            {paymentType === POS && devices.length > 1 ? (
                <div className="mt-2">
                    <label htmlFor={`${idPrefix}-lector`}>¿Con qué POS se cobró?</label>
                    <select
                        id={`${idPrefix}-lector`}
                        className="custom-select"
                        value={posDeviceId}
                        onChange={(e) => setPosDeviceId(e.target.value)}>
                        {devices.map((d) => (
                            <option value={d.id} key={d.id}>{d.name}</option>
                        ))}
                    </select>
                </div>
            ) : ''}
            <small className="text-muted d-block mt-1">
                Entra a la caja abierta con este medio. Sin caja abierta queda pago, pero fuera del arqueo.
            </small>
        </div>
    );
}
